// import React from "react";
// import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
// import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
// import {FormControl, FormLabel} from "@mui/material";
// import style from "../../assets/css/global-fields.module.scss";
// import {DesktopTimePicker, MobileTimePicker} from "@mui/x-date-pickers";
// import dayjs from "dayjs";
// import {isMobile} from "react-device-detect";
// import {Refresh} from "@mui/icons-material";

// const GlobalTimePickerField = ({
//   id,
//   name,
//   title,
//   onChange,
//   onBlur,
//   value = null,
//   minTime = null, // Minimum time constraint
//   maxTime = null, // Maximum time constraint
//   error = false,
//   helperText,
//   disabled = false,
//   clearBtn = false,
// }) => {
//   // Check if value is valid and not the same as minTime or maxTime
//   const isValidTime = (selectedTime) => {
//     if (!selectedTime || !minTime || !maxTime) return true;
//     return (
//       selectedTime.isAfter(dayjs(minTime)) &&
//       selectedTime.isBefore(dayjs(maxTime))
//     );
//   };
//   return (
//     <div className={style.proposalDateField}>
//       <FormControl
//         fullWidth
//         className="GDateField"
//         style={{position: "relative"}}
//       >
//         <LocalizationProvider dateAdapter={AdapterDayjs}>
//           {/* <FormLabel sx={{ mb: 1 }} htmlFor={id}>
//             {title}
//           </FormLabel> */}
//           {isMobile ? (
//             <MobileTimePicker
//               value={value ? dayjs(value) : null}
//               onChange={(newValue) => {
//                 if (isValidTime(newValue)) {
//                   onChange(newValue, name);
//                 }
//               }}
//               onBlur={onBlur}
//               ampm={false} // 24-hour format, change to true for 12-hour format
//               minTime={minTime ? dayjs(minTime) : null}
//               maxTime={maxTime ? dayjs(maxTime) : null}
//               disabled={disabled}
//               slotProps={{
//                 textField: {
//                   id,
//                   name,
//                   error: error,
//                   helperText: helperText,
//                   variant: "outlined",
//                   fullWidth: true,
//                 },
//               }}
//             />
//           ) : (
//             <DesktopTimePicker
//               value={value ? dayjs(value) : null}
//               onChange={(newValue) => {
//                 if (isValidTime(newValue)) {
//                   onChange(newValue, name);
//                 }
//               }}
//               onBlur={onBlur}
//               ampm={false} // 24-hour format, change to true for 12-hour format
//               minTime={minTime ? dayjs(minTime) : null}
//               maxTime={maxTime ? dayjs(maxTime) : null}
//               disabled={disabled}
//               slotProps={{
//                 textField: {
//                   id,
//                   name,
//                   error: error,
//                   helperText: helperText,
//                   variant: "outlined",
//                   fullWidth: true,
//                   placeholder: title,
//                 },
//               }}
//             />
//           )}
//           {clearBtn ? (
//             <div className={style.clearDateBtn}>
//               <Refresh onClick={() => onChange("", name)} />
//             </div>
//           ) : null}
//         </LocalizationProvider>
//       </FormControl>
//     </div>
//   );
// };

// export default GlobalTimePickerField;
import React from "react";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {FormControl} from "@mui/material";
import style from "../../assets/css/global-fields.module.scss";
import {DesktopTimePicker, MobileTimePicker} from "@mui/x-date-pickers";
import dayjs from "dayjs";
import {isMobile} from "react-device-detect";
import {Refresh} from "@mui/icons-material";

const GlobalTimePickerField = ({
  id,
  name,
  title,
  onChange,
  onBlur,
  value = null,
  minTime = null,
  maxTime = null,
  error = false,
  helperText,
  disabled = false,
  clearBtn = false,
}) => {
  const isValidTime = (selectedTime) => {
    if (!selectedTime || !minTime || !maxTime) return true;
    return (
      selectedTime.isAfter(dayjs(minTime)) &&
      selectedTime.isBefore(dayjs(maxTime))
    );
  };

  return (
    <div className={style.proposalDateField}>
      <FormControl
        fullWidth
        className="GDateField"
        style={{position: "relative"}}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {isMobile ? (
            <MobileTimePicker
              value={value ? dayjs(value) : null}
              onChange={(newValue) => {
                if (isValidTime(newValue)) {
                  onChange(newValue, name);
                }
              }}
              onBlur={onBlur}
              ampm={false}
              minTime={minTime ? dayjs(minTime) : null}
              maxTime={maxTime ? dayjs(maxTime) : null}
              disabled={disabled}
              slotProps={{
                textField: {
                  id,
                  name,
                  error,
                  helperText,
                  variant: "outlined",
                  fullWidth: true,
                  inputProps: {
                    readOnly: true,
                    placeholder: title,
                    "aria-label": title || "Select time", // ← Add aria-label here
                  },
                  InputProps: {
                    readOnly: true,
                  },
                  onBlur: () => {
                    if (onBlur) onBlur({target: {name}});
                  },
                },
              }}
            />
          ) : (
            <DesktopTimePicker
              value={value ? dayjs(value) : null}
              onChange={(newValue) => {
                if (isValidTime(newValue)) {
                  onChange(newValue, name);
                }
              }}
              onBlur={onBlur}
              ampm={false}
              minTime={minTime ? dayjs(minTime) : null}
              maxTime={maxTime ? dayjs(maxTime) : null}
              disabled={disabled}
              slotProps={{
                textField: {
                  id,
                  name,
                  error,
                  helperText,
                  variant: "outlined",
                  fullWidth: true,
                  inputProps: {
                    readOnly: true,
                    placeholder: title,
                    "aria-label": title || "Select time", // ← Add aria-label here
                  },
                  InputProps: {
                    readOnly: true,
                  },
                  onBlur: () => {
                    if (onBlur) onBlur({target: {name}});
                  },
                },
              }}
            />
          )}
          {clearBtn && (
            <div className={style.clearDateBtn}>
              <Refresh onClick={() => onChange("", name)} />
            </div>
          )}
        </LocalizationProvider>
      </FormControl>
    </div>
  );
};

export default GlobalTimePickerField;
